import type { TBrazilStatesGeoJSON } from './types'

export const getBrazilStatesGeo = async (): Promise<TBrazilStatesGeoJSON> => {
  const response = await fetch('/assets/json/brazil-states.json', {
    cache: 'force-cache',
  })

  if (!response.ok) {
    throw new Error('Ops! Não foi possível carregar o mapa.')
  }

  return (await response.json()) as TBrazilStatesGeoJSON
}
